import type { ProfileField, ProfileFormData } from "../../types";

export const defaultProfileValues: ProfileFormData = {
  fullName: "",
  email: "",
  cpf: "",
  phone: "",
  isDisabledPerson: false,
  disabilityType: "",
  isAtypicalMother: false,
  businessName: "",
  cnpj: "",
  website: "",
  businessCategory: "",
  participatesInAssociation: false,
  associationName: "",
  instagram: "",
  facebook: "",
  tiktok: "",
  coverImage: null,
  existingCoverImage: null,
  coverImageAlt: "",
  logoImage: null,
  existingLogoImage: null,
  logoImageAlt: "",
  businessDescription: "",
  zipCode: "",
  address: "",
  addressNumber: "",
  addressComplement: "",
  neighborhood: "",
  city: "",
  locationDisplayPreference: "neighborhood_city",
};

export const stepFields: ProfileField[][] = [
  ["phone", "isDisabledPerson", "disabilityType", "isAtypicalMother"],
  [
    "businessName",
    "cnpj",
    "website",
    "businessCategory",
    "participatesInAssociation",
    "associationName",
    "coverImage",
    "coverImageAlt",
    "logoImage",
    "logoImageAlt",
    "businessDescription",
  ],
  [
    "zipCode",
    "address",
    "addressNumber",
    "neighborhood",
    "city",
    "locationDisplayPreference",
  ],
  [],
];

